import { FlexBox, HintTooltip, MagicBox } from "@brg/ui";
import { FC } from "react";
import styled, { css } from "styled-components";
import { ReactComponent as CheckIcon } from "shared/assets/check.svg";
import { ReactComponent as CheckWhite } from "shared/assets/checkWhite.svg";
import { LayoutConst } from "core";

type MagicBoxRowPropsT = {
    checked: boolean;
    label?: string;
    disabled?: boolean;
    style?: any;
    onClick?: (ev: React.SyntheticEvent) => void;
    dark?: boolean;
    hintText?: string;
};

const CheckboxRoot = styled.div<{ checked?: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  // border: 1px solid ${({theme}) => theme.commonCheckbox.border};
  border: 1px solid ${({ theme }) => theme.projectEdit.btns.age.border};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.projectEdit.btns.age.bg};
  input {
    display: none;
  }

  ${({ checked }) => checked ? css`
    svg path {
      fill: ${({ theme }) => theme.projectEdit.btns.age.icon.color};
    }
  ` : null};

`;

const CheckBoxInfoWrapper = styled(FlexBox)`

  .hint-info-icon {
    path {
      fill: #909090;
    }
  }
`;

export const ContentLabel = styled.div`
  // color: ${({theme}) => theme.commonCheckbox.color};
  color: ${({ theme }) => theme.projectEdit.label};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  white-space: pre-wrap;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const CommonCheckbox: FC<MagicBoxRowPropsT> = ({ onClick, checked, disabled, label, style, dark, hintText }) => {

    const baseStyle = { padding: '2px 8px 4px', justifyContent: 'flex-start' };
    const geoStyle ={ background: "#E7E7E7", color: "#70706F", justifyContent: 'flex-start' }
  
    const combinedStyle = { ...baseStyle, ...geoStyle };
  
      return (<MagicBox
          onClick={onClick}
          width="100%"
          pointer
          className={'common-checkbox'}
          disabled={disabled}
          align="center"
          gx={16}
      >
          <CheckboxRoot className={'common-checkbox-outer-container'} checked={checked}>
              {checked && (
                  <>
                      {dark ? <CheckIcon/> : <CheckWhite/>}
                  </>
              )}
              <input checked={checked} type="checkbox" readOnly />
          </CheckboxRoot>
          <CheckBoxInfoWrapper 
            width={hintText ? 'auto' : '100%'} 
            widthMobile={hintText ? 'auto' : '100%'} 
            gx={hintText ? 8 : 1} 
            gxMobile={hintText ? 8 : 1}
            align={hintText ? 'center' : 'normal'}
          >
            <ContentLabel>
                {label}
            </ContentLabel>
            {hintText && (
              <HintTooltip positionY='top' customStyle={combinedStyle} noDisappearDelay onWhiteBg z={1} text={hintText}>
                <svg className='hint-info-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.1246 10.3409V10.2855C7.13076 9.69768 7.19231 9.22988 7.30926 8.8821C7.42621 8.53433 7.5924 8.25272 7.80784 8.03729C8.02327 7.82185 8.2818 7.62334 8.58341 7.44176C8.76499 7.33097 8.9281 7.20017 9.07275 7.04936C9.2174 6.89548 9.33128 6.71851 9.41437 6.51847C9.50055 6.31842 9.54363 6.09683 9.54363 5.85369C9.54363 5.55208 9.47285 5.29048 9.33128 5.06889C9.1897 4.8473 9.00043 4.67649 8.76345 4.55646C8.52647 4.43643 8.26333 4.37642 7.97403 4.37642C7.72166 4.37642 7.47853 4.42874 7.24463 4.53338C7.01073 4.63802 6.8153 4.80268 6.65834 5.02734C6.50138 5.25201 6.41059 5.54593 6.38596 5.90909H5.22261C5.24723 5.38589 5.38265 4.93809 5.62886 4.5657C5.87815 4.1933 6.20592 3.90862 6.61217 3.71165C7.0215 3.51468 7.47545 3.41619 7.97403 3.41619C8.5157 3.41619 8.98658 3.52391 9.38667 3.73935C9.78985 3.95478 10.1007 4.25024 10.3192 4.62571C10.5408 5.00118 10.6516 5.42898 10.6516 5.90909C10.6516 6.24763 10.5993 6.55386 10.4946 6.82777C10.3931 7.10168 10.2453 7.34635 10.0514 7.56179C9.86063 7.77723 9.62981 7.96804 9.35898 8.13423C9.08814 8.3035 8.87117 8.48201 8.70805 8.66974C8.54494 8.8544 8.42645 9.07446 8.35258 9.3299C8.27872 9.58535 8.23871 9.90388 8.23255 10.2855V10.3409H7.1246ZM7.71551 13.0739C7.48776 13.0739 7.29233 12.9923 7.12922 12.8292C6.9661 12.6661 6.88454 12.4706 6.88454 12.2429C6.88454 12.0152 6.9661 11.8197 7.12922 11.6566C7.29233 11.4935 7.48776 11.4119 7.71551 11.4119C7.94326 11.4119 8.13869 11.4935 8.3018 11.6566C8.46492 11.8197 8.54648 12.0152 8.54648 12.2429C8.54648 12.3937 8.50801 12.5322 8.43106 12.6584C8.3572 12.7846 8.25718 12.8861 8.13099 12.9631C8.00789 13.0369 7.86939 13.0739 7.71551 13.0739Z" fill="#909090"/>
                  <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#909090"/>
              </svg>
              </HintTooltip>
            )}
          </CheckBoxInfoWrapper>
      </MagicBox>)
  };import { FlexBox, HintTooltip, MagicBox } from "@brg/ui";
import { FC } from "react";
import styled, { css } from "styled-components";
import { ReactComponent as CheckIcon } from "shared/assets/check.svg";
import { ReactComponent as CheckWhite } from "shared/assets/checkWhite.svg";
import { LayoutConst } from "core";

type MagicBoxRowPropsT = {
    checked: boolean;
    label?: string;
    disabled?: boolean;
    style?: any;
    onClick?: (ev: React.SyntheticEvent) => void;
    dark?: boolean;
    hintText?: string;
};

const CheckboxRoot = styled.div<{ checked?: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  // border: 1px solid ${({theme}) => theme.commonCheckbox.border};
  border: 1px solid ${({ theme }) => theme.projectEdit.btns.age.border};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.projectEdit.btns.age.bg};
  input {
    display: none;
  }

  ${({ checked }) => checked ? css`
    svg path {
      fill: ${({ theme }) => theme.projectEdit.btns.age.icon.color};
    }
  ` : null};

`;

const CheckBoxInfoWrapper = styled(FlexBox)`

  .hint-info-icon {
    path {
      fill: #909090;
    }
  }
`;

export const ContentLabel = styled.div`
  // color: ${({theme}) => theme.commonCheckbox.color};
  color: ${({ theme }) => theme.projectEdit.label};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  white-space: pre-wrap;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const CommonCheckbox: FC<MagicBoxRowPropsT> = ({ onClick, checked, disabled, label, style, dark, hintText }) => {

    const baseStyle = { padding: '2px 8px 4px', justifyContent: 'flex-start' };
    const geoStyle ={ background: "#E7E7E7", color: "#70706F", justifyContent: 'flex-start' }
  
    const combinedStyle = { ...baseStyle, ...geoStyle };
  
      return (<MagicBox
          onClick={onClick}
          width="100%"
          pointer
          className={'common-checkbox'}
          disabled={disabled}
          align="center"
          gx={16}
      >
          <CheckboxRoot className={'common-checkbox-outer-container'} checked={checked}>
              {checked && (
                  <>
                      {dark ? <CheckIcon/> : <CheckWhite/>}
                  </>
              )}
              <input checked={checked} type="checkbox" readOnly />
          </CheckboxRoot>
          <CheckBoxInfoWrapper 
            width={hintText ? 'auto' : '100%'} 
            widthMobile={hintText ? 'auto' : '100%'} 
            gx={hintText ? 8 : 1} 
            gxMobile={hintText ? 8 : 1}
            align={hintText ? 'center' : 'normal'}
          >
            <ContentLabel>
                {label}
            </ContentLabel>
            {hintText && (
              <HintTooltip positionY='top' customStyle={combinedStyle} noDisappearDelay onWhiteBg z={1} text={hintText}>
                <svg className='hint-info-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.1246 10.3409V10.2855C7.13076 9.69768 7.19231 9.22988 7.30926 8.8821C7.42621 8.53433 7.5924 8.25272 7.80784 8.03729C8.02327 7.82185 8.2818 7.62334 8.58341 7.44176C8.76499 7.33097 8.9281 7.20017 9.07275 7.04936C9.2174 6.89548 9.33128 6.71851 9.41437 6.51847C9.50055 6.31842 9.54363 6.09683 9.54363 5.85369C9.54363 5.55208 9.47285 5.29048 9.33128 5.06889C9.1897 4.8473 9.00043 4.67649 8.76345 4.55646C8.52647 4.43643 8.26333 4.37642 7.97403 4.37642C7.72166 4.37642 7.47853 4.42874 7.24463 4.53338C7.01073 4.63802 6.8153 4.80268 6.65834 5.02734C6.50138 5.25201 6.41059 5.54593 6.38596 5.90909H5.22261C5.24723 5.38589 5.38265 4.93809 5.62886 4.5657C5.87815 4.1933 6.20592 3.90862 6.61217 3.71165C7.0215 3.51468 7.47545 3.41619 7.97403 3.41619C8.5157 3.41619 8.98658 3.52391 9.38667 3.73935C9.78985 3.95478 10.1007 4.25024 10.3192 4.62571C10.5408 5.00118 10.6516 5.42898 10.6516 5.90909C10.6516 6.24763 10.5993 6.55386 10.4946 6.82777C10.3931 7.10168 10.2453 7.34635 10.0514 7.56179C9.86063 7.77723 9.62981 7.96804 9.35898 8.13423C9.08814 8.3035 8.87117 8.48201 8.70805 8.66974C8.54494 8.8544 8.42645 9.07446 8.35258 9.3299C8.27872 9.58535 8.23871 9.90388 8.23255 10.2855V10.3409H7.1246ZM7.71551 13.0739C7.48776 13.0739 7.29233 12.9923 7.12922 12.8292C6.9661 12.6661 6.88454 12.4706 6.88454 12.2429C6.88454 12.0152 6.9661 11.8197 7.12922 11.6566C7.29233 11.4935 7.48776 11.4119 7.71551 11.4119C7.94326 11.4119 8.13869 11.4935 8.3018 11.6566C8.46492 11.8197 8.54648 12.0152 8.54648 12.2429C8.54648 12.3937 8.50801 12.5322 8.43106 12.6584C8.3572 12.7846 8.25718 12.8861 8.13099 12.9631C8.00789 13.0369 7.86939 13.0739 7.71551 13.0739Z" fill="#909090"/>
                  <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#909090"/>
              </svg>
              </HintTooltip>
            )}
          </CheckBoxInfoWrapper>
      </MagicBox>)
  };